import reducer from './reducers';
import * as supplementActions from './actions';

export { supplementActions };
export default reducer;
